import {jobsQuery} from './state';
import {dealSignatrue} from '@/assets/js/util';
import api from '@/api';
export const setJobsQuery = ({commit}, data) => {
  let query = {
    ...jobsQuery,
    ...data
  };
  commit('SET_JOBS_QUERY', query);
}
export const setJobs = ({commit}, data) => {
  commit('SET_JOBS', data);
}
export const setCities = ({commit}, data) => {
  for (let i = 1; i < data.length; i++) {
    let temp = {};
    for (let j = i + 1; j < data.length; j++) {
      if (data[i].group_name.charCodeAt(0) > data[j].group_name.charCodeAt(0)) {
        temp = data[i];
        data[i] = data[j];
        data[j] = temp;
      }
    }
  }
  commit('SET_CITIES', data);
}
export const setHotCities = ({commit}, data) => {
  commit('SET_HOT_CITIES', data);
}

// 获取jobs list 列表数据
export const getRecruitInfosIndex = async ({commit}, data) => {
  data = {...data};
  data.city_code = data.city_code - 0 || '';
  data.industry_code = data.industry_code === '000' ? '' : data.industry_code;
  data.city_code = data.city_code == 0 || !data.city_code ? '' : data.city_code ;
  for (let i in data) {
    if (!data[i] || data[i] === '不限') {
      delete data[i];
    }
  }
  let queryData = await dealSignatrue(data);
  // let res = await api.recruit.recruitInfosIndex(queryData);

  await commit('SET_PAGE_TOTAL', res.all_jobs_count || 0);
  await commit('SET_RECRUIT_INFOS', res.recruit_infos || []);
  await commit('SET_CITY_ACTION', res.city_name || '');
  // console.log('\n\n\n\n\n\n=======recruit_infos=========');
  // console.log(res.recruit_infos );
  // if (res.recruit_infos) {
    // console.log('当页数量:' + res.recruit_infos.length);
  // }
  // console.log('总条数:' + res.all_jobs_count);
  // console.log('\n\n\n\n\n\nend');
  // let industries = [...res.industries];
  // industries.unshift({name: '不限', code: ''});
  // commit('SET_INDUSTRIES', industries);
  // return res;
}
// 搜索接口--搜索列表
export const getRecruitInfosSearch = async ({ commit }, company_or_job_name) => {
  let data = {...global.app.store.state.jobs.jobsQuery};
  data.city_code = data.city_code - 0 || '';
  data.industry_code = data.industry_code - 0 || '';
  data.city_code = data.city_code == 0 || !data.city_code ? '' : data.city_code;
  data.industry_code = data.industry_code == 0 || !data.industry_code ? '' : data.industry_code;
  data.city_code;
  data.industries = data.industry_code + '';
  // delete data.city_code;
  delete data.industry_code;
  for (let i in data) {
    if (!data[i] || data[i] === '不限') delete data[i];
  }
  data.company_or_job_name = company_or_job_name;
  let queryData = await dealSignatrue(data);
  let res = await api.recruit.recruitInfosSearch(queryData);

  await commit('SET_RECRUIT_INFOS', res.data.new_recruit_infos || []);
  await commit('SET_PAGE_TOTAL', res.data.all_jobs_count);
  return res;
}
// 获取求职意向
export const getIntention = async ({ commit }, userIntentions) => {
  // 求职意向
  // console.log('====userIntentions1111=========');
  // let queryData = await dealSignatrue();
  // console.log('====userIntentions2222=========');
  // console.log(queryData);
  // let res = await api.recruit.jobIntention(queryData);
  // console.log('====userIntentions3333=========');
  // console.log(res.data);

  // let userIntentions = {...res.data};
  await commit('SET_USER_INTENTIONS', userIntentions);

  // let isTrue = this.userIntentions.work_time === '未开启'
  //   || this.userIntentions.intention_cities === '未开启'
  //   || this.userIntentions.profession_names === '未开启'
  //   || this.userIntentions.industry_names === '未开启';
  // if (isTrue) {
  //   this.editIntentionShow = true;
  //   this.isClose = true;
  // }
}

export const setIsSearch = async ({commit}, data) => {
  await commit('SET_IS_SEARCH', data);
}

export const setIntention = async ({commit}, data) => {
  await commit('SET_INTENTION', data);
}

export const setPage = async ({commit}, data) => {
  await commit('SET_PAGE', data);
}

export const setJobsQueryKeyValue = async ({commit}, data) => {
  await commit('SET_PAGE', 1);
  await commit('SET_JOBS_QUERY_KEY_VALUE', data);
}

export const setJobsQueryPage = async ({commit}, data) => {
  await commit('SET_JOBS_QUERY_PAGE', data)
}

// export const setPageTotal = async ({commit}, data) => {
//   await commit('SET_PAGE_TOTAL', data);
// }

export const searchValue = async ({commit}, data) => {
  await commit('SEARCH_VALUE', data);
}


export const setHostCity = async ({commit}, data) => {
  await commit('SET_HOST_CITY', data);
}

export const setHostIndustries = async ({commit}, data) => {
  await commit('SET_HOST_INDUSTRIES', data);
}

export const setCityAction = async ({commit}, data) => {
  commit('SET_CITY_ACTION', data);
}
export const setIntentionAction = async ({commit}, data) => {
  commit('SET_INTENTION_ACTION', data);
}


export const setIndustries = async ({commit}, data) => {
  commit('SET_INDUSTRIES', data);
}
